//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme   } from '@mui/material/styles' ;
import { Box        } from '@mui/material'        ;
import { ExitToApp  } from '@mui/icons-material'  ;
import { grey       } from '@mui/material/colors' ;

// === HOOKS ===
import { useLogout } from 'components/useLogout';

//#endregion

//-----------------------------------------------------------------
export function LogoutButton() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme  = useTheme();
  const logout = useLogout();

  const _styles = {
    container: {
      display    : 'flex'  ,
      marginLeft : 'auto'  ,
      alignItems : 'center',
      padding    : '1rem'  ,
      '&:hover': {
        background: grey[300],
     },
    },
    text: {
      paddingLeft: '1rem',
    }
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box name='logout_box' sx={_styles.container} onClick={logout}>
        <ExitToApp color='primary'/>
        <Box sx={_styles.text}> Logout </Box>
      </Box>
    );
  }

  //#endregion

  return display();
}
